import React from 'react';
import Layout from '../components/Layout/Layout';
import FaqImg from '../assets/img/faq.jpeg';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Container from '@material-ui/core/Container';
import SEO from '../components/SEO/seo';

export default function FaqPage() {
  return (
    <Layout paralaxImg={FaqImg} heading='Frequently Asked Questions'>
      <SEO
        title='FAQ | Covid Safe | Deelightful Cleaning'
        description='We know you want to be sure before you commit to a cleaning service. That is why we have put together our handy FAQ to answer your questions.'
      />
      <Container maxWidth='md'>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography>Are you cleaning during the COVID Pandemic?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Yes! We're cleaning despite the on-going Pandemic. Our cautious
              practices ensure we keep our customers safe. We may ask you to
              take some precautions prior to us entering your property. These
              are to ensure we are keeping the wellbeing of our staff and you
              safe.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel2a-content'
            id='panel2a-header'
          >
            <Typography>
              I am interested in your Domestic Cleaning Services, where do I
              start?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Get in touch with our team by clicking here. We'll have a quick
              chat to discover your needs and preferences and we'll provide you
              a tailored quote.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel3a-content'
            id='panel3a-header'
          >
            <Typography>
              I am interested in your Commerical Cleaning Services, where do I
              start?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Please get in touch with us and we'll build a tailored quote based
              on the size of your premises, locations and needs. If you have any
              questions we'd love to answer them.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Container>
    </Layout>
  );
}
